import { filterConstants } from "../constants/AppConstants";

export const carparkLog = {
  columns: [
    { key: "transaction_date", header: "Date" },
    { key: "reward_name", header: "Reward Name" },
    { key: "iu_number", header: "IU Number" },
    { key: "vehicle_no", header: "License plate" },
    { key: "transaction_type", header: "Action" },
    { key: "balance", header: "Balance" },
    { key: "redeemCarParkDollars", header: "Redeemed carpark dollars" },
    { key: "utilizedCarParkDollars", header: "Utilized carpark dollars" },
    // { key: "transaction_type", header: "Type" },
    // { key: "amount", header: "Amount" },
  ],
};

export const receipts = {
  columns: [
    { key: "image", header: "Image" },
    { key: "amount", header: "Amount" },
    {
      key: "calculatedReceiptAmount",
      header: "Calculated Receipt Amount",
      filterable: true,
    },
    { key: "merchant", header: "Merchant", searchable: true },
    {
      key: "merchantCategory",
      header: "Merchant Category",
      searchable: true,
    },
    {
      key: "receiptNo",
      header: "Receipt Number",
    },
    {
      key: "submittedDate",
      header: "Submitted Date",
    },
    {
      key: "reviewedDate",
      header: "Reviewed Date",
    },
    {
      key: "pointsAwarded",
      header: "Points Awarded",
    },
    {
      key: "birthdayPoints",
      header: "Birthday Points",
    },
    {
      key: "status",
      header: "Status",
    },
  ],
  data: [
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/9308-SMOOY_1536_x_882.jpg",
      amount: "3284",
      calculatedReceiptAmount: "433",
      merchant: "merchant 1",
      merchantCategory: "Gold",
      receiptNo: "001",
      submittedDate: "02 June 2023",
      reviewedDate: "10 June 2023",
      pointsAwarded: "8329",
      birthdayPoints: "20",
      status: filterConstants.Active,
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/9308-SMOOY_1536_x_882.jpg",
      amount: "3284",
      calculatedReceiptAmount: "433",
      merchant: "merchant 1",
      merchantCategory: "Gold",
      receiptNo: "001",
      submittedDate: "02 June 2023",
      reviewedDate: "10 June 2023",
      pointsAwarded: "8329",
      birthdayPoints: "20",
      status: filterConstants.Active,
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/9308-SMOOY_1536_x_882.jpg",
      amount: "3284",
      calculatedReceiptAmount: "433",
      merchant: "merchant 1",
      merchantCategory: "Gold",
      receiptNo: "001",
      submittedDate: "02 June 2023",
      reviewedDate: "10 June 2023",
      pointsAwarded: "8329",
      birthdayPoints: "20",
      status: filterConstants.Active,
    },
  ],
  metaData: {
    image: {
      isImage: true,
      linkTo: "",
    },
    amount: {
      isImage: false,
      linkTo: "",
    },
    calculatedReceiptAmount: {
      isImage: false,
      linkTo: "",
    },
    merchant: {
      isImage: false,
      linkTo: "",
    },
    merchantCategory: {
      isImage: false,
      linkTo: "",
    },
    receiptNo: {
      isImage: false,
      linkTo: "",
    },
    submittedDate: {
      isImage: false,
      linkTo: "",
    },
    reviewedDate: {
      isImage: false,
      linkTo: "",
    },
    pointsAwarded: {
      isImage: false,
      linkTo: "",
    },
    birthdayPoints: {
      isImage: false,
      linkTo: "",
    },
    status: {
      isImage: false,
      linkTo: "",
    },
  },
};

export const members = {
  columns: [
    { key: "name", header: "Name" },
    { key: "email", header: "Email", searchable: true },
    {
      key: "mobile",
      header: "Mobile",
      // filterable: true,
    },
    //check for loayalty no
    {
      key: "zip",
      header: "Loyalty No",
      //  searchable: true
    },
    {
      key: "member_type",
      header: "Membership",
      // searchable: true,
    },
    //check for tier
    {
      key: "unit_no",
      header: "Tier",
    },
    {
      key: "customer_status",
      header: "Status",
    },
  ],
  data: [
    {
      firstName: "Channabasav",
      email: "channa@gmail.com",
      mobile: "987654321",
      zip: "ABC098",
      member_type: "Customer",
      unit_no: "Gold",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Dhanraj",
      email: "dhanraj@gmail.com",
      mobile: "123456789",
      zip: "DEF123",
      member_type: "Corp",
      unit_no: "Silver",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Channabasav",
      email: "channa@gmail.com",
      mobile: "987654321",
      zip: "ABC098",
      member_type: "Customer",
      unit_no: "Gold",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Dhanraj",
      email: "dhanraj@gmail.com",
      mobile: "123456789",
      zip: "DEF123",
      member_type: "Corp",
      unit_no: "Silver",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Channabasav",
      email: "channa@gmail.com",
      mobile: "987654321",
      zip: "ABC098",
      member_type: "Customer",
      unit_no: "Gold",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Dhanraj",
      email: "dhanraj@gmail.com",
      mobile: "123456789",
      zip: "DEF123",
      member_type: "Corp",
      unit_no: "Silver",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Channabasav",
      email: "channa@gmail.com",
      mobile: "987654321",
      zip: "ABC098",
      member_type: "Customer",
      unit_no: "Gold",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Dhanraj",
      email: "dhanraj@gmail.com",
      mobile: "123456789",
      zip: "DEF123",
      member_type: "Corp",
      unit_no: "Silver",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Channabasav",
      email: "channa@gmail.com",
      mobile: "987654321",
      zip: "ABC098",
      member_type: "Customer",
      unit_no: "Gold",
      member_status: filterConstants.Active,
    },
    {
      firstName: "ZAPCOM",
      email: "zapcom@gmail.com",
      mobile: "123456789",
      zip: "DEF123",
      member_type: "Corp",
      unit_no: "Silver",
      member_status: filterConstants.Active,
    },
    {
      firstName: "Solutions",
      email: "solutions@gmail.com",
      mobile: "123456789",
      zip: "DEF123",
      member_type: "Corp",
      unit_no: "Silver",
      member_status: filterConstants.Active,
    },
  ],
  metaData: {
    firstName: {
      isImage: false,
      linkTo: "",
    },
    email: {
      isImage: false,
      linkTo: `/viewMember`,
    },
    mobile: {
      isImage: false,
      linkTo: "",
    },
    zip: {
      isImage: false,
      linkTo: "",
    },
    member_type: {
      isImage: false,
      linkTo: "",
    },
    unit_no: {
      isImage: false,
      linkTo: "",
    },
    member_status: {
      isImage: false,
      linkTo: "",
    },
  },
};

export const messages = {
  columns: [
    { key: "image", header: "Image" },
    { key: "ticketNo", header: "Ticker Number", searchable: true },
    { key: "inquiryType", header: "Inquiry Type", searchable: true },
    { key: "message", header: "Message", searchable: true },
    { key: "messageDateTime", header: "Message Date Time" },
    { key: "view", header: "View" },
  ],
  data: [
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/2187-Uniqlo_Lifestyle_Image_STC.jpg",
      ticketNo: "001",
      inquiryType: "type 1",
      message: "custom message 1",
      messageDateTime: "30 June 2023",
      view: "view 1",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/2187-Uniqlo_Lifestyle_Image_STC.jpg",
      ticketNo: "001",
      inquiryType: "type 1",
      message: "custom message 1",
      messageDateTime: "30 June 2023",
      view: "view 1",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/2187-Uniqlo_Lifestyle_Image_STC.jpg",
      ticketNo: "001",
      inquiryType: "type 1",
      message: "custom message 1",
      messageDateTime: "30 June 2023",
      view: "view 1",
    },
  ],
  metaData: {
    image: {
      isImage: true,
      linkTo: "",
    },
    ticketNo: {
      isImage: false,
      linkTo: "",
    },
    inquiryType: {
      isImage: false,
      linkTo: "",
    },
    message: {
      isImage: false,
      linkTo: "",
    },
    messageDateTime: {
      isImage: false,
      linkTo: "",
    },
    view: {
      isImage: false,
      linkTo: "",
    },
  },
};

export const favourites = {
  columns: [
    { key: "image", header: "Image" },
    { key: "dealTitle", header: "Deal Title", searchable: true },
    { key: "dealdescription", header: "Deal Description", searchable: true },
    { key: "merchant", header: "merchant", searchable: true },
    {
      key: "dateAddedAsFavourite",
      header: "Date Added As Favourite",
    },
  ],
  data: [
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/7890-SKECHERS_SPONSORED.jpg",
      dealTitle: "Deal 1",
      dealdescription: "test description",
      merchant: "abcd",
      dateAddedAsFavourite: "30 June 2023",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/7890-SKECHERS_SPONSORED.jpg",
      dealTitle: "Deal 1",
      dealdescription: "test description",
      merchant: "abcd",
      dateAddedAsFavourite: "30 June 2023",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/7890-SKECHERS_SPONSORED.jpg",
      dealTitle: "Deal 1",
      dealdescription: "test description",
      merchant: "abcd",
      dateAddedAsFavourite: "30 June 2023",
    },
  ],
  metaData: {
    image: {
      isImage: true,
      linkTo: "",
    },
    dealTitle: {
      isImage: false,
      linkTo: "",
    },
    dealdescription: {
      isImage: false,
      linkTo: "",
    },
    merchant: {
      isImage: false,
      linkTo: "",
    },
    dateAddedAsFavourite: {
      isImage: false,
      linkTo: "",
    },
  },
};

export const utilisedEVoucher = {
  columns: [
    { key: "image", header: "Image" },
    { key: "title", header: "Title", searchable: true },
    { key: "serialNo", header: "Serial Number", searchable: true },
    { key: "merchantName", header: "Merchant Name", searchable: true },
    { key: "transactionId", header: "Transaction ID", searchable: true },
    { key: "redeemedDate", header: "Redeemed Date" },
    { key: "utilisedDate", header: "Utilised Date" },
    { key: "sourceOfVouchers", header: "Source Of Vouchers" },
    { key: "price", header: "price" },
  ],
  data: [
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/6333-BFSF.JPG",
      title: "Testing Deals",
      serialNo: "43728",
      amount: "123",
      merchantName: "Dhanraj",
      transactionId: "43535",
      redeemedDate: "30 June 2023",
      utilisedDate: "30 June 2023",
      sourceOfVouchers: "",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/6333-BFSF.JPG",
      title: "Testing Deals",
      serialNo: "43728",
      amount: "123",
      merchantName: "Dhanraj",
      transactionId: "43535",
      redeemedDate: "30 June 2023",
      utilisedDate: "30 June 2023",
      sourceOfVouchers: "",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/6333-BFSF.JPG",
      title: "Testing Deals",
      serialNo: "43728",
      amount: "123",
      merchantName: "Dhanraj",
      transactionId: "43535",
      redeemedDate: "30 June 2023",
      utilisedDate: "30 June 2023",
      sourceOfVouchers: "",
    },
  ],
  metaData: {
    image: {
      isImage: true,
      linkTo: "",
    },
    title: {
      isImage: false,
      linkTo: "",
    },
    serialNo: {
      isImage: false,
      linkTo: "",
    },
    amount: {
      isImage: false,
      linkTo: "",
    },
    merchantName: {
      isImage: false,
      linkTo: "",
    },
    transactionId: {
      isImage: false,
      linkTo: "",
    },
    redeemedDate: {
      isImage: false,
      linkTo: "",
    },
    utilisedDate: {
      isImage: false,
      linkTo: "",
    },
    sourceOfVouchers: {
      isImage: false,
      linkTo: "",
    },
  },
};

export const redeemedEVoucher = {
  columns: [
    { key: "image", header: "Image" },
    { key: "title", header: "Title", searchable: true },
    { key: "serialNo", header: "Serial Number", searchable: true },
    { key: "redemptionDate", header: "Redemption Date" },
    { key: "pointSpent", header: "Point Spent", searchable: true },
    { key: "expiryDate", header: "Expiry Date" },
    { key: "sourceOfVouchers", header: "Source Of Vouchers" },
    { key: "price", header: "Price" },
  ],
  data: [
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/8564-MicrosoftTeams-image_(16).png",
      title: "new deals",
      serialNo: "33728",
      redemptionDate: "30 June 2023",
      amount: "923",
      pointSpent: "543",
      expiryDate: "30 June 2023",
      sourceOfVouchers: "",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/8564-MicrosoftTeams-image_(16).png",
      title: "current deals",
      serialNo: "23728",
      redemptionDate: "30 June 2023",
      amount: "423",
      pointSpent: "543",
      expiryDate: "30 June 2023",
      sourceOfVouchers: "",
    },
    {
      image:
        "https://suntecproject-stg.s3.amazonaws.com/BI/voucher/thumb/8564-MicrosoftTeams-image_(16).png",
      title: "old deals",
      serialNo: "13728",
      redemptionDate: "30 June 2023",
      amount: "723",
      pointSpent: "543",
      expiryDate: "30 June 2023",
      sourceOfVouchers: "",
    },
  ],
  metaData: {
    image: {
      isImage: true,
      linkTo: "",
    },
    title: {
      isImage: false,
      linkTo: "",
    },
    serialNo: {
      isImage: false,
      linkTo: "",
    },
    redemptionDate: {
      isImage: false,
      linkTo: "",
    },
    amount: {
      isImage: false,
      linkTo: "",
    },
    pointSpent: {
      isImage: false,
      linkTo: "",
    },
    expiryDate: {
      isImage: false,
      linkTo: "",
    },
    sourceOfVouchers: {
      isImage: false,
      linkTo: "",
    },
  },
};

export const loyaltyPoints = {
  columns: [
    { key: "transactionDate", header: "Transaction Date" },
    { key: "transactionType", header: "Transaction Type" },
    { key: "merchantName", header: "Campaign Name/Merchant" },
    { key: "points", header: "Points" },
    { key: "pointsBalance", header: "Points Balance" },
    { key: "pointsExpiry", header: "Points Expiry" },
    { key: "remark", header: "Remark" },
    { key: "createdBy", header: "Created by" },
  ],

  data: [
    {
      transactionDate: "02 June 2023",
      transactionType: "Reward",
      loyaltyPoints: "+10",
      pointsBalance: "3683",
      pointsExpiry: "30 June 2023",
      remarks: "Promocode Bonus",
      createdBy: "Tom Doe",
      submittedBy: "John",
    },
    {
      transactionDate: "02 June 2023",
      transactionType: "Cash",
      loyaltyPoints: "+20",
      pointsBalance: "2683",
      pointsExpiry: "30 June 2023",
      remarks: "Promocode Bonus",
      createdBy: "John Doe",
      submittedBy: "John",
    },
    {
      transactionDate: "02 June 2023",
      transactionType: "Reward",
      loyaltyPoints: "+30",
      pointsBalance: "1683",
      pointsExpiry: "30 June 2023",
      remarks: "Promocode Bonus",
      createdBy: "Sam Doe",
      submittedBy: "John",
    },
  ],
  metaData: {
    transactionDate: {
      isImage: false,
      linkTo: "",
    },
    transactionType: {
      isImage: false,
      linkTo: "",
    },
    loyaltyPoints: {
      isImage: false,
      linkTo: "",
    },
    pointsBalance: {
      isImage: false,
      linkTo: "",
    },
    pointsExpiry: {
      isImage: false,
      linkTo: "",
    },
    remarks: {
      isImage: false,
      linkTo: "",
    },
    createdBy: {
      isImage: false,
      linkTo: "",
    },
    submittedBy: {
      isImage: false,
      linkTo: "",
    },
  },
};
